export const containerListaAguardandoEntregas = {
    overflowY: 'auto',
    padding: '5px 10px',
    height: {
        lg: '55%',
        xl: '70%'
    }
}

export const styleTitulo = {
    display: 'flex',
    alignItems: 'center',
    padding: '5px'
}

export const styleIcon = {
    color: 'black',
    marginRight: '10px'
}

export const typografyListaAguardando = {
    color: 'black',
    fontWeight: '600',
    fontSize: '16px'
}
